var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkalt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 3,
    viewBox: "0 0 3 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0416665 0.458334C0.0416665 0.347827 0.0855652 0.241846 0.163705 0.163706C0.241845 0.0855657 0.347826 0.041667 0.458333 0.041667H2.54167C2.65217 0.041667 2.75815 0.0855657 2.83629 0.163706C2.91443 0.241846 2.95833 0.347827 2.95833 0.458334V2.54167C2.95833 2.65217 2.91443 2.75815 2.83629 2.83629C2.75815 2.91444 2.65217 2.95833 2.54167 2.95833H0.458333C0.347826 2.95833 0.241845 2.91444 0.163705 2.83629C0.0855652 2.75815 0.0416665 2.65217 0.0416665 2.54167V0.458334ZM2.33333 0.666667H0.666666V2.33333L1.5 1.91667L2.33333 2.33333V0.666667Z",
    fill: "#47D16C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkalt);
export default __webpack_public_path__ + "static/media/Bookmark alt.5fc2fa50e00a941100810d8571610ee3.svg";
export { ForwardRef as ReactComponent };